import { Alert } from 'antd';

export function UpdateBanner() {
  return (
    <Alert
      banner
      type="info"
      showIcon
      message="Hay una actualización disponible."
      action={
        <a onClick={() => window.location.reload()} style={{ cursor: 'pointer', fontWeight: 600 }}>
          Recargar
        </a>
      }
      style={{ position: 'sticky', top: 0, zIndex: 1000 }}
    />
  );
}
